import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import { strings } from '@constants'
import { getBankDetails, updateAccountDetails } from '@data'
import { showLoader, showToast } from '@data/state/action'
import { toggleDrawer } from '@data/state/action/root'
import { DrawerBodyWrapper, DrawerFooterWrapper, TOAST_TYPE } from '@base'
import { Button, Input, Select } from '@baseV2'

import { InputsWrapper } from '../styles'

const AddBank = ({ orgId, update, orgName }) => {
	const dispatch = useDispatch()
	const [bankList, setBankList] = useState([])
	const [bank, setBank] = useState({})
	const [ifsc, setIfsc] = useState('')
	const [accountNumber, setAccountNumber] = useState('')
	const [accountHolderName, setAccountHolderName] = useState(orgName)
	const [displayName, setDisplayName] = useState('')

	useEffect(() => {
		getBankDetails()
			.then((res) => setBankList(res ?? []))
			.catch((err) => console.log(err))
	}, [])

	const isDisabled = !bank?.institution_id || !ifsc

	const addBankAccount = () => {
		if (isDisabled) return
		dispatch(showLoader(true))

		const accountDetails = {
			bank_name: bank?.name,
			ifsc_code: ifsc,
			account_number: accountNumber,
			account_holder_name: accountHolderName,
			name: displayName
		}
		
		updateAccountDetails(orgId, accountDetails)
			.then(() => {
				dispatch(showToast(true, strings('msg_account_added_success'), { type: TOAST_TYPE.SUCCESS }))
				dispatch(toggleDrawer(false))
				update?.()
			})
			.catch((err) => {
				console.log(err)
				dispatch(showToast(true, strings('msg_account_added_failure'), { type: TOAST_TYPE.ERROR }))
			})
			.finally(() => dispatch(showLoader(false)))
	}

	return (
		<>
			<DrawerBodyWrapper>
				<InputsWrapper>
					<Input
						id='account-holder-name'
						label={strings(['acoount', 'holder', 'name'])}
						value={accountHolderName}
						onChange={(e) => setAccountHolderName(e.target.value ?? '')}
						placeholder={strings(['enter', 'holder', 'name'])}
					/>
					<Select
						id='bank-name-v2'
						label={strings('select', 'bank')}
						placeholder={strings(['enter', 'bank', 'name'])}
						data={bankList}
						displayKey='name'
						primaryKey='institution_id'
						value={bank}
						onChange={setBank}
					/>
					<Input
						id='bank-ifsc-v2'
						label={strings('ifsc')}
						value={ifsc}
						onChange={(e) => setIfsc((e.target.value ?? '').toUpperCase())}
						placeholder={strings(['enter', 'ifsc', 'code'])}
					/>
					<Input
						id='bank-account-number-v2'
						label={strings('account', 'number')}
						value={accountNumber}
						onChange={(e) => setAccountNumber((e.target.value ?? '').toUpperCase())}
						placeholder={strings(['enter', 'account', 'number'])}
					/>
					<Input
						id='display-name'
						label={strings('display', 'name')}
						value={displayName}
						onChange={(e) => setDisplayName(e.target.value ?? '')}
						placeholder={strings(['enter', 'display', 'name'])}
					/>
				</InputsWrapper>
			</DrawerBodyWrapper>
			<DrawerFooterWrapper>
				<Button color='primary' disabled={isDisabled} onClick={addBankAccount}>
					{strings('add')}
				</Button>
			</DrawerFooterWrapper>
		</>
	)
}

export default AddBank
